import { useAppSelector } from "../../redux/store";
import { selectMenuTagFilters } from "../../redux/selectors/selectMenuTagFilters";
import { useIntl } from "react-intl";
import MenuTag from "../../models/menu/MenuTag.tsx";

export default function useMenuTagFilters() {
  const intl = useIntl();
  const menuTags = useAppSelector((state) => selectMenuTagFilters(state, intl));

  return Object.values(menuTags).filter((menuTag): menuTag is MenuTag => Boolean(menuTag));
}
